const ecosystem = process.env.REACT_APP_ECOSYSTEM;

let config;

try {
  config = require(`./${ecosystem}/index.js`).default;
} catch (error) {
  console.error(
    `Configuration pour l'écosystème "${ecosystem}" non trouvée. Utilisation de la configuration par défaut.`,
    error
  );
}

export default config;
